import React from 'react'
import { Button, ButtonProps } from 'react-bootstrap'

export default function CloseButton({ className, ...rest }: ButtonProps) {
    return (
        <Button variant='clear' className={`p-0 ${className}`} {...rest}><i className='bi bi-x h2' /></Button>
    )
}
